import { CheckBox, FieldLabel, styled } from "@monolith-forensics/monolith-ui";
import { WebhookEventDefinitions } from "../WebhookEventDefinitions";

const StyledDescription = styled.p`
  margin: 0px;
  font-size: 11px;
  color: ${(props) => props.theme.palette.text.secondary};
`;

export const WebhookEventSelector: React.FC<{
  value?: string[];
  onChange?: (value: string[]) => void;
  error?: string;
}> = ({ value = [], onChange, error }) => {
  return (
    <div>
      <FieldLabel error={error}>Webhook Events</FieldLabel>
      <StyledDescription>
        Subscribe this webhook to specific resource events that occur in
        Monolith. When a creation, update, or delete event occurs to any
        subscribed resource, the webhook call will be made by Monolith.
      </StyledDescription>
      <div
        style={{
          marginTop: 20,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
          gap: 10,
        }}
      >
        {WebhookEventDefinitions.map((event) => {
          return (
            <div
              key={event.value}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 5,
                textTransform: "capitalize",
                userSelect: "none",
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
              }}
              onClick={() => {
                if (value.includes(event.value)) {
                  onChange?.(value.filter((v: any) => v !== event.value));
                } else {
                  onChange?.([...value, event.value]);
                }
              }}
            >
              <CheckBox
                size="sm"
                value={value.includes(event.value)}
                onChange={(e) => {
                  if (e) {
                    onChange?.([...value, event.value]);
                  } else {
                    onChange?.(value.filter((v: any) => v !== event.value));
                  }
                }}
              />
              {event.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
